var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2633",
    "data-name": "Group 2633",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15874",
    "data-name": "Path 15874",
    d: "M125.37,43.17a12,12,0,1,1,12-12A12.015,12.015,0,0,1,125.37,43.17Zm0-22.857A10.857,10.857,0,1,0,136.228,31.17,10.87,10.87,0,0,0,125.37,20.313Z",
    transform: "translate(-113.37 -19.17)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15875",
    "data-name": "Path 15875",
    d: "M133.6,46.373a2.54,2.54,0,0,1-2.357-1.76,2.536,2.536,0,0,0,1.086-.033.165.165,0,0,0,.036-.018,2.535,2.535,0,0,1-1.647-1.162,2.45,2.45,0,0,1-.372-1.348,2.519,2.519,0,0,0,1.13.306,2.546,2.546,0,0,1-1.042-1.538,2.51,2.51,0,0,1,.273-1.836,7.247,7.247,0,0,0,5.229,2.649c-.015-.1-.029-.189-.04-.277a2.535,2.535,0,0,1,4.31-2.1.127.127,0,0,0,.135.04,5.12,5.12,0,0,0,1.476-.568c.011-.007.022-.011.033-.018s.007,0,.018,0a2.588,2.588,0,0,1-1.086,1.381,4.958,4.958,0,0,0,1.41-.379l.011.011c-.1.128-.189.255-.292.379a4.989,4.989,0,0,1-.922.874.081.081,0,0,0-.04.08,6.85,6.85,0,0,1-.047,1.126,7.493,7.493,0,0,1-.652,2.255,7.294,7.294,0,0,1-1.37,2A6.77,6.77,0,0,1,135.4,48.38a7.682,7.682,0,0,1-1.414.168,7.143,7.143,0,0,1-4.055-1.089l-.058-.04a5.129,5.129,0,0,0,2.536-.35A4.894,4.894,0,0,0,133.6,46.373Z",
    transform: "translate(-123.543 -31.162)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.357cf8afb0e6a5929fff61121938f99d.svg";
export { ForwardRef as ReactComponent };